
const firebaseConfig = {
  apiKey: "AIzaSyAImU7vw_vEr84GPuFekC3DGTMvlNkufwQ",
  authDomain: "dental-services-bd530.firebaseapp.com",
  projectId: "dental-services-bd530",
  storageBucket: "dental-services-bd530.appspot.com",
  messagingSenderId: "969665647461",
  appId: "1:969665647461:web:5663f921b7afaa8a26c78c"
};

  export default firebaseConfig;






  // const firebaseConfig = {
  //   apiKey: "AIzaSyAV2RdVIFUbAQ4XM5XlTKzrtRgfazUODdg",
  //   authDomain: "dental-care-unit.firebaseapp.com",
  //   projectId: "dental-care-unit",
  //   storageBucket: "dental-care-unit.appspot.com",
  //   messagingSenderId: "247033753965",
  //   appId: "1:247033753965:web:66353ce5adb470c8ffea64"
  // };